import { useContext } from "react";
// ** Custom Components
import Text from "components/typography/Text";
import Block from "components/layout/Block";
import Login from "components/user/Login";
import UserAvatar from "components/user/UserAvatar";

// ** Utils & Helpers
import { VIP_STATUS } from "helpers/constants";

// ** Contexts
import deviceTypeContext from "contexts/deviceTypeContext";

// ** Third Party Components
import { useTranslation } from "react-i18next";

// #####################################################

const ChattingWith = ({
	conversationUser,
	chatPartnerOnlineStatus,
	chatPartnerProfileStatus,
}) => {
	const { t } = useTranslation(["userpanel"]);

	const { isPhone } = useContext(deviceTypeContext);

	return (
		<Block flex justifyCenter alignCenter style={{ margin: "0 auto" }}>
			<Text
				mr={2}
				style={{
					textAlign: "center",
					fontSize: "0.85rem" /* small */,
				}}
			>
				{t("userpanel:messages.chattingWith")}
			</Text>
			<Block flex mr={2}>
				<UserAvatar
					userId={conversationUser?.id}
					size="xsmall"
					link
					src={conversationUser.avatar}
					login={conversationUser.login}
					online={
						chatPartnerOnlineStatus &&
						chatPartnerOnlineStatus !== null
							? chatPartnerOnlineStatus
							: conversationUser.online
					}
					privateData={conversationUser.private_data}
					status={
						chatPartnerProfileStatus &&
						chatPartnerProfileStatus !== null
							? chatPartnerProfileStatus
							: conversationUser.profile_status
					}
				/>
			</Block>
			<Login
				link
				login={conversationUser.login}
				vip={
					conversationUser?.showStatusVip === false
						? conversationUser.status_vip > VIP_STATUS.VERIFIED
							? VIP_STATUS.VERIFIED
							: conversationUser.status_vip
						: conversationUser.status_vip
				}
				oneLine={!isPhone}
				maxWidthWithEllipsis={isPhone ? 150 : 350}
				size="xsmall" /* small */
				vipProps={{ marginBottom: 0 }}
			/>
		</Block>
	);
};

// ####################################################

export default ChattingWith;

// ####################################################
